import { Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoginComponent } from '../components/pages/login/login.component';
import { LoginAuthGuard } from './login-auth-guard.service';
import { AdminDashboardComponent } from "../components/admin/admin-dashboard/admin-dashboard.component";
import { AuthGuardService } from "./auth-guard.service";
import { AdminClientListComponent } from "../components/admin/admin-client-list/admin-client-list.component";
import { DeviceReportsCopyComponent } from '../components/client/device-reports-copy/device-reports-copy.component';
import { OperationalReportsComponent } from '../components/operational-reports/operational-reports.component';
import { AuditComponent } from '../components/user/audit/audit.component';
import { ErrorLogComponent } from '../components/admin/error-log/error-log.component';
import { ServiceLogsComponent } from '../components/service-logs/service-logs.component';
import { AlertListComponent } from '../components/client/alert-list/alert-list.component';
import { AdminDeviceListComponent } from '../components/admin/admin-device-list/admin-device-list.component';
import { SiteInchargeComponent } from '../components/admin/site-incharge/site-incharge.component';
import { DeviceVersioningComponent } from '../components/admin/device-versioning/device-versioning.component';
import { DeviceTypeListingComponent } from '../components/admin/device-type-listing/device-type-listing.component';
import { LicenceManagementComponent } from '../components/admin/licence-management/licence-management.component';
import { SiteMaintenanceComponent } from '../components/admin/site-maintenance/site-maintenance.component';
import { ReportsComponent } from '../components/user/reports/reports.component';
import { ClientAddAssetsComponent } from '../components/client/client-add-assets/client-add-assets.component';
import { DeviceReportsComponent } from '../components/client/device-reports/device-reports.component';
import { AdminCreateClientsComponent } from '../components/admin/admin-create-clients/admin-create-clients.component';
import { CreatePowertrainComponent } from '../components/client/powertrain/create-powertrain/create-powertrain.component';
import { CreatePowertrainFormComponent } from '../components/client/powertrain/create-powertrain-form/create-powertrain-form.component';
import { EditPowertrainComponent } from '../components/client/powertrain/edit-powertrain/edit-powertrain.component';
import { DeviceDetailNxtV2Component } from '../components/client/device-detail-nxt-v2/device-detail-nxt-v2.component';
import { EnergyMeterMonitoringComponent } from '../components/client/energy-meter-monitoring/energy-meter-monitoring.component';
import { BoilerRoomDeviceComponent } from '../components/eBoiler/boiler-room-device/boiler-room-device.component';
import { EboilerDashboardComponent } from '../components/eBoiler/eboiler-dashboard/eboiler-dashboard.component';
import { ParametersListComponent } from '../components/eBoiler/parameters-list/parameters-list.component';
import { TransformersComponent } from '../components/client/transformers/transformers.component';
import { AnalysisComponent } from '../components/client/analysis/analysis.component';
import { AdminUserComponent } from '../components/admin/admin-user/admin-user.component';
import { ClientUserListComponent } from '../components/client/client-user-list/client-user-list.component';
import { AddSiteGroupComponent } from '../components/client/add-site-group/add-site-group.component';
import { SiteAndGroupsComponent } from '../components/client/site-and-groups/site-and-groups.component';
import { AddUsersComponent } from '../components/client/add-users/add-users.component';
import { ConfiguratorComponentComponent } from '../components/boiler-configurator/configurator-component/configurator-component.component';
import { ClientListComponent } from '../components/Incharge/client-list/client-list.component';
import { CreateSiteInchargeComponent } from '../components/admin/create-site-incharge/create-site-incharge.component';
import { PlantDashboardComponent } from '../components/client/plant-dashboard/plant-dashboard.component';
import { ElectricalSignatureAnalysisComponent } from '../components/client/electrical-signature-analysis/electrical-signature-analysis.component';
import { AddLicenceManagementComponent } from '../components/admin/add-licence-management/add-licence-management.component';
import { QRLoginComponent } from '../components/pages/qr-login/qr-login.component';
import { ChangePasswordComponent } from '../components/pages/change-password/change-password.component';
import { ForgotPasswordComponent } from '../components/pages/forgot-password/forgot-password.component';
import { DeepDetailInfoComponent } from '../components/user/deep-detail-info/deep-detail-info.component';
import { DeviceDetailComponent } from '../components/user/device-detail/device-detail.component';
import { DeviceDetailNewComponent } from '../components/user/device-detail-new/device-detail-new.component';
import { ClientGroupListingComponent } from '../components/client/client-group-listing/client-group-listing.component';
import { ManagerGroupListingComponent } from '../components/manager/manager-group-listing/manager-group-listing.component';
import { ManagerAssetsComponent } from '../components/manager/manager-assets/manager-assets.component';
import { ManagerAddAssetsComponent } from '../components/manager/manager-add-assets/manager-add-assets.component';
import { AddGroupComponent } from '../components/client/add-group/add-group.component';
import { ManagerAddGroupComponent } from '../components/manager/manager-add-group/manager-add-group.component';
import { ManagerAddSiteGroupComponent } from '../components/manager/manager-add-site-group/manager-add-site-group.component';
import { SiteAndGroupComponent } from '../components/manager/site-and-group/site-and-group.component';
import { ClientListsComponent } from '../components/manager/client-lists/client-lists.component';
import { AccountsManagerDashboardComponent } from '../components/manager/accounts-manager-dashboard/accounts-manager-dashboard.component';
import { AdminProfileComponent } from '../components/admin/admin-profile/admin-profile.component';
import { AdminUserCreateComponent } from '../components/admin/admin-user-create/admin-user-create.component';
import { AdminAddDeviceTypeComponent } from '../components/admin/admin-add-device-type/admin-add-device-type.component';
import { FirstEnerticsComponent } from './first-enertics/first-enertics.component';
import { AdminCreateDeviceComponent } from '../components/admin/admin-create-device/admin-create-device.component';
import { BoilerRoomComponent } from '../components/eBoiler/boiler-room/boiler-room.component';
import { EmConfiguratorMappingComponent } from './em-configurator-mapping/em-configurator-mapping.component';
import { DeviceDetailNxtComponent } from '../components/client/device-detail-nxt/device-detail-nxt.component';
import { EnergyMeterConfigurationComponent } from '../components/client/energy-meter-configuration/energy-meter-configuration.component';
import { EnergyMeterComponent } from '../components/client/energy-meter/energy-meter.component';
import { OEMClientListComponent } from '../components/OEM-User/oem-client-list/oem-client-list.component';
import { WaterDeviceListComponent } from '../components/water-management/water-device-list/water-device-list.component';
import { CyclinderDashboardComponent } from '../components/cyclinders/cyclinder-dashboard/cyclinder-dashboard.component';
import { CreateCyclinderComponent } from '../components/cyclinders/create-cyclinder/create-cyclinder.component';
import { OvenDeviceListComponent } from '../components/oven-system/oven-device-list/oven-device-list.component';
import { OvenDashboardComponent } from '../components/oven-system/oven-dashboard/oven-dashboard.component';
import { JobDialogBoxComponent } from '../components/oven-system/job-dialog-box/job-dialog-box.component';
import { GaugeMonitoringDashboardComponent } from '../components/client/gauge-monitoring-dashboard/gauge-monitoring-dashboard.component';
import { DeviceUsageComponent } from './device-usage/device-usage.component';
import { ClientsSubscriptionComponent } from '../components/admin/clients-subscription/clients-subscription.component';
import { MySubscriptionComponent } from '../components/client/my-subscription/my-subscription.component';
import { PiezeoSensorMonitoringComponent } from '../components/client/piezeo/piezeo-sensor-monitoring/piezeo-monitoring.component';
import { UptimeDashboardComponent } from '../components/client/uptime/dashboard/uptime-dashboard.component';
import { AdditionalParamsComponent } from '../components/oven-system/additionalParams/additional-params.component';
import { PiezeoCreateComponent } from '../components/client/piezeo/piezeo-create/piezeo-create.component';
import { PiezeoFormComponent } from '../components/client/piezeo/piezeo-form-create/piezeo-form.component';
import { PiezeoEditFormComponent } from '../components/client/piezeo/piezeo-form-edit/piezeo-form-edit.component';
import { PiezeoEditComponent } from '../components/client/piezeo/piezeo-edit/piezeo-edit.component';
import { PiezoDashboard } from '../components/client/piezeo/piezo-dashboard/piezo-dashboard.component';
import { PiezoSensorDashboard } from '../components/client/piezeo/piezo-sensor-dashboard/piezo-sensor-dashboard.component';

export const routes: Routes  = [
  {
    path: "audit",
    component: AuditComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "Error-log",
    component: ErrorLogComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "site-incharge",
    component: SiteInchargeComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "incharge-client-list",
    component: ClientListComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "create-site-incharge",
    component: CreateSiteInchargeComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: "reports",
    canActivate: [AuthGuardService],
    component: ReportsComponent,
  },
  {
    path: "plant-dashboard",
    canActivate: [AuthGuardService],
    component: PlantDashboardComponent,
  },
  {
    path: "detail-nxt",
    canActivate: [AuthGuardService],
    component: DeviceDetailNxtComponent,
  },
  {
    path: "detail-nxt-v2",
    canActivate: [AuthGuardService],
    component: DeviceDetailNxtV2Component,
  },
  {
    path: "ElectricalSignatureAnalysis",
    canActivate: [AuthGuardService],
    component: ElectricalSignatureAnalysisComponent,
  },
  {
    path: "add-licence",
    canActivate: [AuthGuardService],
    component: AddLicenceManagementComponent,
  },
  {
    path: "licence-management",
    canActivate: [AuthGuardService],
    component: LicenceManagementComponent,
  },
  {
    path: "login",
    component: LoginComponent,
    canActivate:[LoginAuthGuard]
  },

  {
    path: "QRlogin",
    component: QRLoginComponent,
  },
  {
    path: "forgot-password",
    component: ForgotPasswordComponent,
  },
  {
    path: "change-password",
    canActivate: [AuthGuardService],
    component: ChangePasswordComponent,
  },
  {
    path: "deep-link-detail",
    canActivate: [AuthGuardService],
    component: DeepDetailInfoComponent,
  },
  {
    path: "device-report-new",
    canActivate: [AuthGuardService],
    component: DeviceReportsCopyComponent,
  },
  {
    path: "deep-link-detail/:id",
    canActivate: [AuthGuardService],
    component: DeepDetailInfoComponent,
  },
  {
    path: "user-device-info",
    canActivate: [AuthGuardService],
    component: DeviceDetailComponent,
  },
  {
    path: "user-device-info-new",
    canActivate: [AuthGuardService],
    component: DeviceDetailNewComponent,
  },

  {
    path: "client-group-list",
    canActivate: [AuthGuardService],
    component: ClientGroupListingComponent,
  },
  {
    path: "device-versioning",
    canActivate: [AuthGuardService],
    component: DeviceVersioningComponent,
  },
  {
    path: "client-group-list/:id",
    canActivate: [AuthGuardService],
    component: ClientGroupListingComponent,
  },
  {
    path: "manager-group-list",
    canActivate: [AuthGuardService],
    component: ManagerGroupListingComponent,
  },
  {
    path: "manager-assets",
    canActivate: [AuthGuardService],
    component: ManagerAssetsComponent,
  },
  {
    path: "manager-add-assets",
    canActivate: [AuthGuardService],
    component: ManagerAddAssetsComponent,
  },
  {
    path: "clients-add-assets",
    canActivate: [AuthGuardService],
    component: ClientAddAssetsComponent,
  },
  {
    path: "add-group",
    canActivate: [AuthGuardService],
    component: AddGroupComponent,
  },
  {
    path: "manager-add-group",
    canActivate: [AuthGuardService],
    component: ManagerAddGroupComponent,
  },
  {
    path: "manager-site-group",
    canActivate: [AuthGuardService],
    component: ManagerAddSiteGroupComponent,
  },
  {
    path: "add-site-and-groups",
    canActivate: [AuthGuardService],
    component: AddSiteGroupComponent,
  },
  {
    path: "manager-users-site-group",
    canActivate: [AuthGuardService],
    component: SiteAndGroupComponent,
  },
  {
    path: "manager-client-list",
    canActivate: [AuthGuardService],
    component: ClientListsComponent,
  },
  {
    path: "manager-dashboard",
    canActivate: [AuthGuardService],
    component: AccountsManagerDashboardComponent,
  },
  {
    path: "admin-profile",
    canActivate: [AuthGuardService],
    component: AdminProfileComponent,
  },
  {
    path: "admin-users",
    canActivate: [AuthGuardService],
    component: AdminUserComponent,
  },
  {
    path: "admin-create-users",
    canActivate: [AuthGuardService],
    component: AdminUserCreateComponent,
  },
  {
    path: "view-device-type",
    canActivate: [AuthGuardService],
    component: DeviceTypeListingComponent,
  },
  {
    path: "add-device-type",
    canActivate: [AuthGuardService],
    component: AdminAddDeviceTypeComponent,
  },
  {
    path: "add-user",
    canActivate: [AuthGuardService],
    component: AddUsersComponent,
  },
  {
    path: "add-user/:id",
    canActivate: [AuthGuardService],
    component: AddUsersComponent,
  },
  {
    path: "",
    component: FirstEnerticsComponent,
  },
  {
    path: "users",
    canActivate: [AuthGuardService],
    component: ClientUserListComponent,
  },
  {
    path: "site-groups",
    canActivate: [AuthGuardService],
    component: SiteAndGroupsComponent,
  },
  {
    path: "device-reports",
    canActivate: [AuthGuardService],
    component: DeviceReportsComponent,
  },
  {
    path: "admin-dashborad",
    canActivate: [AuthGuardService],
    component: AdminDashboardComponent,
  },
  {
    path: "clients",
    canActivate: [AuthGuardService],
    component: AdminClientListComponent,
  },
  {
    path: "devices",
    canActivate: [AuthGuardService],
    component: AdminDeviceListComponent,
  },
  {
    path: "add-client",
    canActivate: [AuthGuardService],
    component: AdminCreateClientsComponent,
  },
  {
    path: "add-device",
    canActivate: [AuthGuardService],
    component: AdminCreateDeviceComponent,
  },
  {
    path: "operation-reports",
    canActivate: [AuthGuardService],
    component: OperationalReportsComponent,
    children: [
      {
        path: "audit",
        component: AuditComponent,
      },
      { path: "error-log", component: ErrorLogComponent },
      { path: "service-logs", component: ServiceLogsComponent },
      { path: "", redirectTo: "audit", pathMatch: "full" }, // Default to audit if no child path is provided
    ],
  },
  {
    path: "alert-list",
    canActivate: [AuthGuardService],
    component: AlertListComponent,
  },
  {
    path: "OEM-Client",
    canActivate: [AuthGuardService],
    component: OEMClientListComponent,
  },
  {
    path: "energy-meter",
    canActivate: [AuthGuardService],
    component: EnergyMeterComponent,
  },
  {
    path: "energy-meter-configuration",
    canActivate: [AuthGuardService],
    component: EnergyMeterConfigurationComponent,
  },
  {
    path: "energy-meter-configuration-mapping",
    canActivate: [AuthGuardService],
    component: EmConfiguratorMappingComponent,
  },
  {
    path: "Transformer-list",
    canActivate: [AuthGuardService],
    component: TransformersComponent,
  },
  {
    path: "transformer-analysis",
    canActivate: [AuthGuardService],
    component: AnalysisComponent,
  },
  {
    path: "energy-meter-monitoring",
    canActivate: [AuthGuardService],
    component: EnergyMeterMonitoringComponent,
  },
  {
    path: "site-maintenance",
    canActivate: [AuthGuardService],
    component: SiteMaintenanceComponent,
  },
  {
    path: "eBoiler-room",
    canActivate: [AuthGuardService],
    component: BoilerRoomComponent,
  },
  {
    path: "eBoiler-room-devices",
    canActivate: [AuthGuardService],
    component: BoilerRoomDeviceComponent,
  },
  {
    path: "eBoiler-dashboard",
    canActivate: [AuthGuardService],
    component: EboilerDashboardComponent,
  },
  {
    path: "eboiler-parameters",
    canActivate: [AuthGuardService],
    component: ParametersListComponent,
  },
  {
    path: "powertrain-create",
    canActivate: [AuthGuardService],
    component: CreatePowertrainComponent,
  },
  {
    path: "powertrain-edit",
    canActivate: [AuthGuardService],
    component: EditPowertrainComponent,
  },
  {
    path: "powertrain-create-form",
    canActivate: [AuthGuardService],
    component: CreatePowertrainFormComponent,
  },
  {
    path: "cyclinder-create-form",
    canActivate: [AuthGuardService],
    component: CreateCyclinderComponent,
  },
  {
    path: "cyclinder-dasboard",
    canActivate: [AuthGuardService],
    component: CyclinderDashboardComponent,
  },
  {
    path:"boiler-configurator",
    canActivate:[AuthGuardService],
    component: ConfiguratorComponentComponent,
  },
  {
    path: "water-device-list",
    canActivate: [AuthGuardService],
    component: WaterDeviceListComponent,
  }, {
    path: "oven-devices-list",
    canActivate: [AuthGuardService],
    component: OvenDeviceListComponent
  },
  {
    path: "oven-dashboard",
    canActivate: [AuthGuardService],
    component: OvenDashboardComponent,
  },
  {
    path: "job-dialog-box",
    canActivate: [AuthGuardService],
    loadComponent: () => import ('../../src/components/oven-system/job-dialog-box/job-dialog-box.component').then((m) =>
      m.JobDialogBoxComponent
    )
  },
   {
    path: "gauge-monitoring-dasboard",
    canActivate: [AuthGuardService],
    component: GaugeMonitoringDashboardComponent,
  },
   {
    path: "device-usage",
    canActivate: [AuthGuardService],
    component: DeviceUsageComponent,
  },
   {
    path: "clients-subscription",
    canActivate: [AuthGuardService],
    component: ClientsSubscriptionComponent,
  },
   {
    path: "my-subscription",
    canActivate: [AuthGuardService],
    component: MySubscriptionComponent,
  },
   {
    path: "piezo-service",
    canActivate: [AuthGuardService],
    component: PiezeoSensorMonitoringComponent,
  },
   {
    path: "uptime-dashboard",
    canActivate: [AuthGuardService],
    component: UptimeDashboardComponent,
  },
   {
    path: "oven-additional-params",
    canActivate: [AuthGuardService],
    component: AdditionalParamsComponent,
  },
  {
    path: "piezeo-create",//drag-drop creation
    canActivate: [AuthGuardService],
    component: PiezeoCreateComponent,
  },
  {
    path: "piezeo-edit",//drag-drop creation
    canActivate: [AuthGuardService],
    component: PiezeoEditComponent,
  },
  {
    path: "piezeo-create-form", // forms
    canActivate: [AuthGuardService],
    component: PiezeoFormComponent,
  },
  {
    path: "piezeo-edit-form", // forms
    canActivate: [AuthGuardService],
    component: PiezeoEditFormComponent,
  },
  {
    path: "piezeo-dashboard", // forms
    canActivate: [AuthGuardService],
    component: PiezoDashboard,
  },
  {
    path: "piezeo-sensor-dashboard", // forms
    canActivate: [AuthGuardService],
    component: PiezoSensorDashboard,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'ignore', useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
